<mtg-table>
  <mtg-table-header-row mtgSticky="top" [top]="headerHeight">
    <mtg-table-identity-col></mtg-table-identity-col>
    <mtg-table-col-group title="Результаты" *ngIf="gameResultsVisible">
      <mtg-table-col class="border" *ngFor="let tournamentTeam of teams; let i = index;">
        <span class="chess-title">{{ i + 1 }}</span>
      </mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group title="Игры">
      <mtg-table-col>игр</mtg-table-col>
      <mtg-table-col>побед</mtg-table-col>
      <mtg-table-col
        *ngIf="tournament.settings.overtimeType === overtimeTypes.without_overtime"
      >ничьих</mtg-table-col>
      <mtg-table-col>поражений</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group title="Игровые очки">
      <mtg-table-col>набрано</mtg-table-col>
      <mtg-table-col>пропущено</mtg-table-col>
      <mtg-table-col>+/-</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group title="Попытки">
      <mtg-table-col>совершено</mtg-table-col>
      <mtg-table-col>пропущено</mtg-table-col>
      <mtg-table-col>+/-</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group title="Турнирные очки">
      <mtg-table-col *ngIf="tournament.settings.bonusPointsEnabled">бонусы за атаку</mtg-table-col>
      <mtg-table-col *ngIf="tournament.settings.bonusPointsEnabled">бонусы за защиту</mtg-table-col>
      <mtg-table-col>всего</mtg-table-col>
    </mtg-table-col-group>
  </mtg-table-header-row>
  <mtg-table-row *ngFor="let roundTeam of teams; let i = index;">
    <mtg-table-identity-col>
      <div class="number">{{ i + 1 }}</div>
      <div class="photo">
        <a
          [routerLink]="getTeamPageRoute(roundTeam.tournamentTeam.team.id)"
          queryParamsHandling="preserve"
        >
          <img [src]="roundTeam.tournamentTeam.logo.path"
               *ngIf="roundTeam.tournamentTeam.logo.path"
               [alt]="roundTeam.tournamentTeam.name"
          />
          <div [class]="roundTeam.tournamentTeam.team.getEmptyLogoClass()" *ngIf="!roundTeam.tournamentTeam.logo.path"></div>
        </a>
      </div>
      <div class="info">
        <div class="name">
          <a
            [routerLink]="getTeamPageRoute(roundTeam.tournamentTeam.team.id)"
            queryParamsHandling="preserve"
          >{{ roundTeam.tournamentTeam.name }}</a>
        </div>
      </div>
    </mtg-table-identity-col>
    <mtg-table-col-group *ngIf="gameResultsVisible">
      <mtg-table-col class="dashed-border" *ngFor="let competitorTeam of teams; let j = index;">
        <ng-container *ngIf="competitorTeam.id === roundTeam.id">
          <mtg-svg-icon icon="icons-rugby"></mtg-svg-icon>
        </ng-container>
        <ng-container *ngIf="competitorTeam.id !== roundTeam.id">
          <span *ngIf="(roundTeam.gamesMapping[competitorTeam.tournamentTeam.team.id] || []).length <= 0">- : -</span>
          <a
            *ngFor="let game of (roundTeam.gamesMapping[competitorTeam.tournamentTeam.team.id] || [])"
            [routerLink]="getGameRoute(game.id)"
            class="game-link"
          >
            {{ game.teamId === roundTeam.tournamentTeam.team.id ? game.teamScore : game.competitorTeamScore }}
            :
            {{ game.teamId === roundTeam.tournamentTeam.team.id ? game.competitorTeamScore : game.teamScore }}
          </a>
        </ng-container>
      </mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group>
      <mtg-table-col>{{ roundTeam.gamesCount }}</mtg-table-col>
      <mtg-table-col>{{ roundTeam.wonGamesCount }}</mtg-table-col>
      <mtg-table-col
        *ngIf="tournament.settings.overtimeType === overtimeTypes.without_overtime"
      >{{ roundTeam.drawGamesCount }}</mtg-table-col>
      <mtg-table-col>{{ roundTeam.loseGamesCount }}</mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group>
      <mtg-table-col>{{ roundTeam.scoreSum }}</mtg-table-col>
      <mtg-table-col>{{ roundTeam.missedSum }}</mtg-table-col>
      <mtg-table-col>
        {{ roundTeam.scoreSum > roundTeam.missedSum ? '+' : '' }}
        {{ roundTeam.scoreSum - roundTeam.missedSum }}
      </mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group>
      <mtg-table-col>{{ roundTeam.triesScored }}</mtg-table-col>
      <mtg-table-col>{{ roundTeam.triesMissed }}</mtg-table-col>
      <mtg-table-col>
        {{ roundTeam.triesScored > roundTeam.triesMissed ? '+' : '' }}
        {{ roundTeam.triesScored - roundTeam.triesMissed }}
      </mtg-table-col>
    </mtg-table-col-group>
    <mtg-table-col-group>
      <mtg-table-col *ngIf="tournament.settings.bonusPointsEnabled">{{ roundTeam.attackBonuses }}</mtg-table-col>
      <mtg-table-col *ngIf="tournament.settings.bonusPointsEnabled">{{ roundTeam.defenseBonuses }}</mtg-table-col>
      <mtg-table-col>{{ roundTeam.points || 0 }}</mtg-table-col>
    </mtg-table-col-group>
  </mtg-table-row>
</mtg-table>
